import React from 'react';
import { Select } from 'antd';

export default function TopDropdown({
  val,
  label,
  placeholder,
  data,
  classString = '',
  changeCallback,
  notFound,
  ...props
}) {
  return (
    <div className="flex flex-col">
      <div className="text-sm text-darkerGray max-w-full mb-1">{label}</div>
      <Select
        value={val}
        className={` ${classString}`}
        placeholder={placeholder}
        onChange={changeCallback}
        notFoundContent={notFound}
        options={data}
        {...props}
      />
    </div>
  );
}
